const LOGO_MARK = `${process.env.PUBLIC_URL || ""}/brand/deepaarogya-logo.png`;
const LOGO_FULL = `${process.env.PUBLIC_URL || ""}/brand/deepaarogya-logo-full.png`;

const SIZES = {
  mark: { width: 40, height: 40 },
  nav: { width: 42, height: 42 },
  full: { width: 168, height: 36 },
};

export default function BrandLogo({ variant = "full", className = "", alt = "Deepaarogya AI", priority = false }) {
  const isMark = variant === "mark" || variant === "nav";
  const src = isMark ? LOGO_MARK : LOGO_FULL;
  const size = SIZES[variant] ?? SIZES.full;

  return (
    <img
      src={src}
      alt={alt}
      className={`brand-logo brand-logo-${variant} ${className}`.trim()}
      width={size.width}
      height={size.height}
      style={{ objectFit: "contain", display: "block" }}
      decoding="async"
      fetchpriority={priority ? "high" : undefined}
      loading={priority ? "eager" : "lazy"}
      onError={(e) => {
        e.currentTarget.src = LOGO_MARK;
      }}
    />
  );
}

export { LOGO_MARK, LOGO_FULL };
